import React from 'react';
import { useTranslation } from '../../../contexts/TranslationContext';

interface AuthTabsProps {
  activeTab: 'login' | 'register';
  onTabChange: (tab: 'login' | 'register') => void;
}

const AuthTabs: React.FC<AuthTabsProps> = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();
  
  const tabs = [
    { id: 'login' as const, labelKey: 'auth.login' },
    { id: 'register' as const, labelKey: 'auth.create_account' },
  ];

  return (
    <div className="flex gap-2 mb-8">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`flex-1 py-3 px-6 rounded-lg font-semibold text-sm transition-smooth ${
            activeTab === tab.id
              ? 'bg-primary text-primary-foreground elevation-sm'
              : 'bg-muted text-muted-foreground hover:bg-muted/80'
          }`}
        >
          {t(tab.labelKey)}
        </button>
      ))}
    </div>
  );
};

export default AuthTabs;